import { render, staticRenderFns } from "./HeaderAdsBanner.vue?vue&type=template&id=12ba7997&scoped=true"
import script from "./HeaderAdsBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderAdsBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderAdsBanner.vue?vue&type=style&index=0&id=12ba7997&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba7997",
  null
  
)

export default component.exports